import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { ModelCardsPage } from "@/features/model-cards";

const modelCardsSearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  limit: z.coerce.number().int().min(1).max(100).catch(10),
  q: z.string().optional(),
  status: z.string().optional(),
  environment: z.string().optional(),
  currency: z.string().optional(),
  modelCardId: z.string().optional(),
});

export const Route = createFileRoute("/model-cards/")({
  validateSearch: modelCardsSearchSchema,
  component: () => (
    <PermissionGuard module="model_cards">
      <ModelCardsPage />
    </PermissionGuard>
  ),
});
